var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBouteilleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "bouteilleIcon_svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.877,
    height: 21.404,
    viewBox: "0 0 4.877 21.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bouteilleIcon_svg .a{fill:#e74e0f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M422.439,281.67h-1.884c-.3,0-.555.047-.555-.517v-13c0-2.794,1.687-1.3,1.687-3.669v-3.534c0-.658.092-.681.289-.681h.924c.2,0,.289.024.289.681v3.534c0,2.372,1.687.875,1.687,3.669v13c0,.564-.254.517-.555.517Z",
    transform: "translate(-420 -260.267)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBouteilleIcon);
export default __webpack_public_path__ + "static/media/bouteilleIcon.0a2feeb6.svg";
export { ForwardRef as ReactComponent };